export default "__VITE_ASSET__d904cd80__"